import { render, staticRenderFns } from "./FilesApp.vue?vue&type=template&id=e1f85142"
import script from "./FilesApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesApp.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports